import React from 'react';
import Button from '../../../components/ui/Button';

const QuizNavigation = ({ 
  currentQuestion, 
  totalQuestions, 
  canGoNext, 
  canGoPrevious,
  onPrevious, 
  onNext, 
  onSubmit,
  showFeedback,
  onContinue
}) => {
  const isLastQuestion = currentQuestion === totalQuestions;

  return (
    <div className="bg-card border-t border-border">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 lg:px-8 py-4 md:py-6">
        <div className="flex items-center justify-between gap-4">
          <Button
            variant="outline"
            onClick={onPrevious}
            disabled={!canGoPrevious}
            iconName="ChevronLeft"
            iconPosition="left"
            className="min-w-[100px] md:min-w-[120px]"
          >
            Précédent
          </Button>

          <div className="flex items-center gap-2">
            {Array.from({ length: totalQuestions }, (_, i) => (
              <div
                key={i}
                className={`
                  w-2 h-2 md:w-2.5 md:h-2.5 rounded-full transition-smooth
                  ${i < currentQuestion ? 'bg-primary' : i === currentQuestion - 1 ? 'bg-primary/50' : 'bg-muted'}
                `}
                aria-label={`Question ${i + 1}`}
              />
            ))}
          </div>

          {showFeedback ? (
            <Button
              variant="default"
              onClick={onContinue}
              iconName="ChevronRight"
              iconPosition="right"
              className="min-w-[100px] md:min-w-[120px]"
            >
              Continuer
            </Button>
          ) : isLastQuestion ? (
            <Button
              variant="default"
              onClick={onSubmit}
              disabled={!canGoNext}
              iconName="Check"
              iconPosition="right"
              className="min-w-[100px] md:min-w-[120px]"
            >
              Terminer
            </Button>
          ) : (
            <Button
              variant="default"
              onClick={onNext}
              disabled={!canGoNext}
              iconName="ChevronRight"
              iconPosition="right"
              className="min-w-[100px] md:min-w-[120px]"
            >
              Suivant
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuizNavigation;